import { Component, OnDestroy, inject } from '@angular/core';
import { IWizardModel } from '@mwe/models';
import { EnvironmentService, LoggingService, ProductAddStateService, ProductService } from '@mwe/services';
import { ADD_PRODUCTS_CHOOSE_ROUTE, ADD_PRODUCTS_NO_BIRTHDATE_ROUTE, ADD_PRODUCTS_ROUTE, ADD_PRODUCTS_SEARCH_ROUTE } from '@mwe/constants';
import { WizardComponent } from '@mwe/ui/components';
import { RouterOutlet } from '@angular/router';
import { ProductAddFooterComponent } from '../product-add-footer/product-add-footer.component';

@Component({
  selector: 'mwe-product-add-wizard-base',
  templateUrl: './product-add-wizard-base.component.html',
  imports: [WizardComponent, RouterOutlet, ProductAddFooterComponent],
})
export class ProductAddWizardBaseComponent implements OnDestroy {
  private productAddStateService = inject(ProductAddStateService);
  private productService = inject(ProductService);
  private loggingService = inject(LoggingService);
  private environmentService = inject(EnvironmentService);

  wizardModel: IWizardModel;

  constructor() {
    this.wizardModel = {
      titleKey: 'products-add.title',
      isDeepLinkEnabled: true,
      useMoreWidth: true,
      wizardSteps: [
        {
          titleKey: `products-add.product-search.contentTitle.${this.environmentService.getPortalCustomerType()}`,
          progressBarLabel: 'products-add.product-search.progressBarLabel',
          path: `/${ADD_PRODUCTS_ROUTE}/${ADD_PRODUCTS_SEARCH_ROUTE}`,
          prevButtonLabel: 'products-add.product-search.cancel',
          nextButtonLabel: 'products-add.product-search.submit',
        },
        {
          titleKey: `products-add.product-choose.contentTitle.${this.environmentService.getPortalCustomerType()}`,
          progressBarLabel: 'products-add.product-choose.progressBarLabel',
          path: `/${ADD_PRODUCTS_ROUTE}/${ADD_PRODUCTS_CHOOSE_ROUTE}`,
          prevButtonLabel: 'products-add.product-choose.cancel',
          nextButtonLabel: 'products-add.product-choose.submit',
          isPrimaryHoverButton: true,
        },
        // this step should never be reached by wizard-nav-logic. special step for no-birthdate-error
        {
          hideFromProgressBar: true,
          path: `/${ADD_PRODUCTS_ROUTE}/${ADD_PRODUCTS_NO_BIRTHDATE_ROUTE}`,
          prevButtonLabel: 'products-add.no-birthdate-in-sap.btnGoToProductsOverview',
          nextButtonLabel: 'products-add.no-birthdate-in-sap.btnAddNewProducts',
        },
      ],
    };
  }

  async ngOnDestroy(): Promise<void> {
    if (
      !this.productAddStateService.associationCompleted &&
      this.productAddStateService.associationStatus === null &&
      this.productAddStateService.systemId
    ) {
      try {
        await this.productService.deleteTemporaryAssociations(
          this.productAddStateService.businessPartnerNumber,
          this.productAddStateService.systemId,
        );
      } catch (error) {
        this.loggingService.logError(error, `delete temporary association failed`);
      }
    }
    this.productAddStateService.clearData();
  }
}
